<template>
  <!-- 部屋マスタ画面 -->
  <v-container>
    <v-form ref="tableForm" v-model="tableForm" lazy-validation>
      <v-card flat>
        <v-row>
          <v-col cols="2" class="headerTitle">
            <ryou-select class="bukens1" :items="buildItems" :label="'物件名'" :itemText="'building_name'"
              :itemValue="'building_id'" v-model="selectBuild" :value="selectBuild">
            </ryou-select>
          </v-col>
          <v-col cols="2" class="headerTitle">
            <ryou-select class="bukens2" :items="roomItems" :label="'部屋種類'" :itemText="'code_text'"
              :itemValue="'code_value'" v-model="select" :value="select">
            </ryou-select>
          </v-col>
          <v-col cols="2" class="headerTitle">
            <ryou-checkbox v-model="checkbox1" :value="checkbox1" :label="'自動計算チェック'">
            </ryou-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1" class="headerTitle">
            <div>
              築年数
            </div>
          </v-col>
          <v-col cols="1" class="headerTitle">
            <div>
              {{this.buildingAge}}
            </div>
          </v-col>
          <v-col cols="1" class="headerTitle">
            <div>
              物件広さ
            </div>
          </v-col>
          <v-col cols="1" class="headerTitle">
            <div>
              {{this.buildingTubo}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <ryou-input style="width: 100%;" label="部屋単価" :rules="inputRulesFive" v-model="room_unit_price"
              :value="room_unit_price" :maxlength="5">
            </ryou-input>
          </v-col>
          <v-col cols="2">
            <ryou-black-btn :label="'設定'" :handlerClick="handleRoomCostAdd" :disabled="btnCtrl" :iconCls="'mdi-pencil'">
            </ryou-black-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class='detail' flat>
        <v-row>
          <v-col col="2">
            <ryou-table ref="ryouTable" :rowKey="rowKey" :headers="headers" :url="url" :handleEdit="handleEdit"
              :handleAdd="$useRoomAddition ? handleAdd : null" :businessKeys="businessKeys" :showSelect="showSelect" :singleSelect="singleSelect"
              :queryParams="queryParam" style="margin-top: 10px;" :height="height">
            </ryou-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ryou-black-btn :label="'削除'" :handlerClick="batchDel" :iconCls="'mdi-delete'">
            </ryou-black-btn>
          </v-col>
          <v-col>
            <ryou-blue-btn v-if="$useRoomAddition" :label="'新規追加'" :handlerClick="handleRoomAdd" :disabled="btnCtrl" :dark="colorCtrl">
            </ryou-blue-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-form>

    <master-room-provide-dialog ref="modalForm" @ok="modalFormOk" :url="url" :loadFlag="isload" >
    </master-room-provide-dialog>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-container>
</template>

<script>
  import RyouSelect from "@/components/formInput/RyouSelect.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
  import RyouTable from "@/components/table/RyouTable.vue";
  import RyouCheckbox from "@/components/formInput/RyouCheckbox.vue";

  import MasterRoomProvideDialog from "./modules/MasterRoomProvideDialog.vue";
  import { RyouTableMixins } from "@/mixins/RyouTableMixins";
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

  export default {
    name: "MasterRoom",
    mixins: [RyouTableMixins],
    components: {
      RyouSelect,
      RyouBlackBtn,
      RyouBlueBtn,
      RyouInput,
      RyouTable,
      RyouCheckbox,
      MasterRoomProvideDialog,
      RyouConfirm

    },
    data() {
      return {
        btnCtrl: true,
        colorCtrl: false,
        btnCtrl1: true,
        rowKey: "rowIndex",
        tableForm: true,
        checkbox1: true,
        inputRulesFive: [],
        room_unit_price: "",
        showSelect: true,
        singleSelect: false,
        select: "",
        selectBuild: "",
        buildItems: [],
        isload: false,
        buildingAge: "",
        buildingTubo: "",
        roomItems: [],
        businessKeys: ["building_id", "room_id"],
        height: 600,
        tableName: "ryouTable",
        headers: [
          {
            text: "部屋番号",
            class: "blue lighten-2 title",
            value: "room_id",
            width: "140px",
            sortable: true,
            groupable: false
          },
          {
            text: "使用状況",
            class: "blue lighten-2 title",
            value: "use_status_name",
            width: "140px",
            sortable: true,
            groupable: false
          },
          {
            text: "階",
            class: "blue lighten-2 title",
            value: "floor",
            width: "100px",
            sortable: true,
            groupable: false
          },
          {
            text: "性別",
            class: "blue lighten-2 title",
            value: "sex_name",
            width: "100px",
            sortable: true,
            groupable: false
          },
            {
                text: "部屋別調整代",
                class: "blue lighten-2 title",
                value: "unit_price",
                width: "100px",
                sortable: true,
                groupable: false
            },
          {
            text: "操作",
            class: "blue lighten-2 title",
            value: "actions",
            align: "center",
            width: "120px",
            sortable: false,
            groupable: false
          },
          {
            text: "",
            value: "building_id",
            width: "0.1%",
            type: "hidden",
            sortable: false,
            groupable: false
          },
          {
            text: "",
            value: "sex",
            width: "0.1%",
            type: "hidden",
            sortable: false,
            groupable: false
          },
          {
            text: "",
            value: "use_status",
            width: "0.1%",
            type: "hidden",
            sortable: false,
            groupable: false
          },
          {
            text: "",
            value: "room_class",
            width: "0.1%",
            type: "hidden",
            sortable: false,
            groupable: false
          }
        ],

        url: {
          //list: "/masterRoom/roomGet/" + "999",
          originlist: "/masterRoom/roomGet/",
          deleteBatch: "/masterRoom/roomDelete",
          add: "/masterRoom/roomInsert",
          //copyAdd: "/masterRoom/roomCopyAdd",
          update: "/masterRoom/roomUpdate",
        },
        height: "600px",
      }
    },
    mounted() {
      this.inputRulesFive.push(this.GlobalRules.currency);
      this.$refs.ryouTable.$on("doHandleGridAdd", this.doHandleGridAdd);
    },
    created() {

      this.initData();
    },
    watch: {
      selectBuild(value) {
        this.$refs.tableForm.resetValidation();
        this.select = "";
        this.onClearSelected();
        this.$refs.ryouTable.selected = [];

        var that = this;
        if (value != null && value != "") {
          this.btnCtrl1 = false;
            this.btnCtrl = false;
            this.colorCtrl = true;
          that.$refs.ryouTable.url.list = that.url.originlist + value + "/9999";//
          that.$refs.ryouTable.loadData();
          that.handleBuildJohoGet(value);
        }
        else if (value == "") {
          this.btnCtrl = true;
          this.colorCtrl = false;
          this.btnCtrl1 = true;
          this.buildingAge = "";
          this.buildingTubo = "";
          this.$refs.ryouTable.dataSource = [];
        }
      },
      select(value) {
        this.$refs.tableForm.resetValidation();
        var that = this
        if (value != null && value != "" && !this.btnCtrl1) {
          this.roomUnitPriceGet(value);
          
        }
        else if (value == "") {
          this.room_unit_price = "";
          value = "9999"
        }
        if (this.selectBuild != "") {
          that.$refs.ryouTable.url.list = that.url.originlist + this.selectBuild + "/" + value;//
          that.$refs.ryouTable.loadData();
        }   
      }
    },
    methods: {
      initData() {
        let params = {
          userId: this.$store.getters.getUserId,
          userClass: this.$store.getters.getUserClass,
        }
            this.getRequest("/masterRoom/buildingGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success) {
            this.buildItems = data.result;//物件名
            this.buildItems.push(this.selectBuild);
            if(this.$store.getters.getUserClass != '1'){
              //総務以外は初期値セット
              this.selectBuild = data.result[0].building_id //物件ID
            }
          }
        });

            this.getRequest("/masterRoom/roomKindGet", null ,this.$store.getters.getUserToken).then(data => {
          if (data.success) {
            this.roomItems = data.result[0].children;//種類
            this.roomItems.push(this.select);
          }
        });

        var that = this;
        if (this.$route.params.building_id != null && this.$route.params.building_id != "") {

          that.url.list = that.url.originlist + this.$route.params.building_id;
          that.selectBuild = this.$route.params.building_id;
          //that.handleBuildJohoGet(that.selectBuild);
        } else {
          that.url.list = that.url.originlist + "9999"+"/" + "9999";
          //that.selectBuild = 1;
          //that.handleBuildJohoGet(that.selectBuild);
        }
        //that.$refs.ryouTable.loadData();

      },

      handleRoomCostAdd() {
        this.inputRulesFive.push(this.GlobalRules.required);
        this.inputRulesFive.push(this.GlobalRules.currency);
        var valid = this.$refs.tableForm.validate();
        if (valid) {
          //画面の項目データ取得
          let params = {
            user_id: this.$store.getters.getUserId,
            building_id: this.selectBuild,
            room_class: this.select,
            //room_class_name: this.select.itemText,
            room_unit_price: this.room_unit_price,
          };
          //部屋料金マスタ登録・更新
            this.postRequest("/masterRoom/roomCostInsert", params, this.$store.getters.getUserToken).then((resp) => {
            //画面表示
            if (resp.success) {
              this.$refs.ryouTable.loadData();
            }
          });
          setTimeout(() => {
            return;
          }, 100);
        }
        //this.$refs.tableForm.resetValidation();
      },

      handleRoomAdd() {
        this.$refs.tableForm.resetValidation();
        this.isload = false;
        this.$refs.modalForm.add(this.selectBuild);
      },

      handleBuildJohoGet(value) {
        this.$refs.tableForm.resetValidation();
        if (value != null) {
          let params = {
            building_id: value,
          }
            this.getRequest("/masterRoom/buildingJohoGet", params, this.$store.getters.getUserToken).then(data => {
            this.buildingAge = data.result[0]
            this.buildingTubo = data.result[1]
          });
        }
        else {
          this.buildingAge = "";
          this.buildingTubo = "";
        }
      },

      roomUnitPriceGet(value) {
        this.$refs.tableForm.resetValidation();
        //if ((value == 1 || value == 2) && this.selectBuild != null && this.checkbox1) {
        if ((value != 9999 || value != "") && this.selectBuild != null && this.checkbox1) {
          let params = {
            building_id: this.selectBuild,
            room_class: value,
          }
            this.getRequest("/masterRoom/roomCostJohoGet", params, this.$store.getters.getUserToken).then(data => {
            this.room_unit_price = data.result
          });
        }
        else {
          this.room_unit_price = "";
        }
      },

      doHandleGridAdd(record) {
        this.$refs.tableForm.resetValidation();
        let copyParams = {
          user_id: this.$store.getters.getUserId,
          building_id: record.building_id,
          room_id: record.room_id,
          room_class: record.room_class,
          floor: record.floor,
          use_status: record.use_status,
          sex: record.sex,
          unit_price: record.unit_price,
        };
          this.postRequest("/masterRoom/roomCopyAdd", copyParams, this.$store.getters.getUserToken).then((resp) => {
          //画面表示
          if (resp.success) {
            this.$refs.ryouTable.loadData();
          }
        });

        setTimeout(() => {
          return;
        }, 100);
      },

      add(item) {
        this.$refs.tableForm.resetValidation();
        this.$refs.modalForm.add(item.room_id);
      },

      //bgFilter(value) {
      //  if (!this.select) {
      //   return true;
      // }
      // return value.toLowerCase().includes(this.select.toLowerCase());
      // },
    }
  };
</script>

<style scoped>
  .detail {
    outline: 1px solid rgb(147, 179, 204);
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 0px;
  }

  .headerTitle {
    padding-bottom: 0px;
  }

  .buken {
    width: 150px;
    height: 60px;
    padding-top: 2%;
  }

  .bukens1 {
    width: 300px;
    height: 50px;
  }

  .bukens2 {
    width: 200px;
    height: 50px;
  }

  .bukens {
    float: left;
    box-sizing: border-box;
  }
</style>